// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"10eca942","236":"b8b78653"}[chunkId] + ".chunk.js";
};